import { materializeSnippets } from '@sceneio/snippets-tools'
import { BlockType } from './contentSliceTypes'
import { SnippetType } from '@sceneio/snippets-tools/lib/snippetsTypes'
import { MaterializeSnippetDataType } from '@sceneio/snippets-tools/lib/materializeSnippets'

export const materializeContentBlock = ({
  block,
  snippets,
}: {
  block: BlockType
  snippets: SnippetType[]
}) => {
  let materializedBlock = materializeSnippets({
    data: block as MaterializeSnippetDataType,
    snippets,
  })

  const isReusableContentBlockDraft =
    Object.keys(block?.reusableContentBlockDraft || {}).length > 0

  if (isReusableContentBlockDraft) {
    materializedBlock = {
      ...materializedBlock,
      reusableContentBlockDraft: materializeSnippets({
        data: (block?.reusableContentBlockDraft ||
          {}) as MaterializeSnippetDataType,
        snippets: snippets,
      }),
    }
  }

  return materializedBlock
}

export const reorderBlockIds = (
  blocks: BlockType[],
  selectedBlockIds: string[],
  toIndex: number,
): string[] => {
  // Handle out normalizedIndex bounds toIndex'
  let normalizedIndex = toIndex > blocks.length ? blocks.length : toIndex
  // Handle negative index by treating it as 0
  normalizedIndex = Math.max(0, normalizedIndex)

  // Sort selected blocks by their original order
  const sortedSelectedBlockIds = [...selectedBlockIds].sort((a, b) => {
    const blockA = blocks.find((block) => block.id === a)
    const blockB = blocks.find((block) => block.id === b)
    return (blockA?.order ?? 0) - (blockB?.order ?? 0)
  })

  // Get all block IDs in their original order
  const allBlockIds = blocks.map((block) => block.id)

  // Insert sorted selected blocks at target position
  const withInsertedBlocks = [
    ...allBlockIds.slice(0, normalizedIndex),
    ...sortedSelectedBlockIds,
    ...allBlockIds.slice(normalizedIndex),
  ]

  // Find positions of selected blocks
  const selectedBlockPositions = selectedBlockIds.map(
    (_, index) => normalizedIndex + index,
  )

  // Remove original positions of selected blocks
  const result = withInsertedBlocks.filter((id, index) => {
    if (selectedBlockIds.includes(id)) {
      return selectedBlockPositions.includes(index)
    }
    return true
  })

  return result
}
